import { render, staticRenderFns } from "./ThreeTierKYC.vue?vue&type=template&id=73b3015d&"
import script from "./ThreeTierKYC.vue?vue&type=script&lang=js&"
export * from "./ThreeTierKYC.vue?vue&type=script&lang=js&"
import style0 from "./ThreeTierKYC.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports